import React, { useState, useRef } from "react";
import logo from '../image/logo.png'
import plan1 from '../image/plan1.png'
import plan2 from '../image/plan2.png'
import plan3 from '../image/plan3.png'
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Zoom,
  CircularProgress,
  IconButton
} from "@mui/material";
import { Container } from "@mui/material";
import UseWhatsapp from "whatsapp-react-component";
import { CheckCircleOutlineOutlined } from "@mui/icons-material";
import { CancelOutlined } from "@mui/icons-material";
import testimoni1 from "../image/testimoni1.jpg";
import testimoni2 from "../image/testimoni2.jpg";
import testimoni3 from "../image/testimoni3.jpg";
import testimoni4 from "../image/testimoni4.jpg";
import testimoni5 from "../image/testimoni5.jpg";
import testimoni6 from "../image/customer6.jpg";
import CheckIcon from "@mui/icons-material/Check";
import emailjs from "emailjs-com";
import foto1 from "../image/foto1.webp";
import foto2 from "../image/foto2.jpg";
import foto3 from "../image/foto3.png";
import foto4 from "../image/foto4.png";
import foto5 from '../image/foto5.png';
import foto6 from '../image/foto6.png';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadLinksPreset } from "@tsparticles/preset-links";
import "@fontsource/montserrat";
import "@fontsource/niconne";

export const handleClick = (me) => {
  const whatsappNumber = "+6285178231007"; // format internasional
  const message = "Halo, saya ingin Konsultasi tentang website Anda."; // pesan otomatis
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); // buka WhatsApp Web / App
  };

export default function Home() {

 const [open, setOpen] = useState(false);
const [formData, setFormData] = useState({ customer: "", hp: "", email: "" });
const [loading, setLoading] = useState(false);
const [result, setResult] = useState(null); // null | "success" | "error"
const [errors, setErrors] = useState({
  customer: "",
  hp: "",
  email: ""
});

 const pricingPlans = [
  {
    name: "Plan 1",
    price: "Rp 1.650.000",
    img: plan1,
    features: [
      "5 Halaman",
      "5 Hari Pengerjaan",
      "1x Revisi",
      "1 SEO Keyword",
      "5 page SEO Dasar",
      "10 Upload Setup Gambar",
      "+3 Akun Email",
      "GRATIS! SSL",
      "GRATIS! DOMAIN .COM/CO.ID",
      "Mobile Friendly",
    ],
  },
  {
    name: "Plan 2",
    price: "Rp 2.400.000",
    img: plan2,
    features: [
      "10 Halaman",
      "7 Hari Pengerjaan",
      "3x Revisi",
      "2 SEO Keyword",
      "10 page SEO Dasar",
      "20 Upload Setup Gambar",
      "+5 Akun Email",
      "GRATIS! SSL",
      "GRATIS! DOMAIN .COM/CO.ID",
      "Mobile Friendly",
    ],
  },
  {
    name: "Plan 3",
    price: "Rp 3.150.000",
    img: plan3,
    features: [
      "20 Halaman",
      "14 Hari Pengerjaan",
      "5x Revisi",
      "3 SEO Keyword",
      "20 page SEO Dasar",
      "50 Upload Setup Gambar",
      "+10 Akun Email",
      "GRATIS! SSL",
      "GRATIS! DOMAIN .COM/CO.ID",
      "Mobile Friendly",
    ],
  },
];

const [init, setInit] = React.useState(false);

  // Inisialisasi Engine
  React.useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadLinksPreset(engine);
    }).then(() => setInit(true));
  }, []);

const whatsappRef = useRef(null);

const handleClickPaket = (me) => {
  const whatsappNumber = "+6285178231007"; // format internasional
  const message = "Halo, saya ingin mengajukan pemesanan paket"; // pesan otomatis
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); // buka WhatsApp Web / App
  };


const [animateRadar, setAnimateRadar] = useState(false);


const fiturList = [
    {
      title: "Desain Menarik",
      desc: "Tampilan yang elegan dan profesional untuk menarik perhatian pengunjung.",
      img: foto1,
    },
    {
      title: "Harga Terjangkau",
      desc: "Nikmati layanan premium dengan biaya yang sesuai anggaran bisnis Anda.",
      img: foto2,
    },
    {
      title: "Cepat & Responsif",
      desc: "Website cepat diakses dan tampilan menyesuaikan semua perangkat.",
      img: foto3,
    },
    {
      title: "Support Penuh",
      desc: "Kami siap membantu dari pembuatan hingga pemeliharaan situs Anda.",
      img: foto4,
    },
    {
      title: "SEO Friendly",
      desc: "Website dioptimalkan agar mudah ditemukan di mesin pencari seperti Google, membantu meningkatkan visibilitas bisnis Anda.",
      img: foto5,
    },
    {
      title: "Kustomisasi Fleksibel",
      desc: "Setiap website disesuaikan dengan kebutuhan dan identitas brand Anda, tidak template umum yang seragam.",
      img: foto6,
    },
  ];


  const [formDataLangganan, setFormDataLangganan] = useState({
    message: "",
    mobileNumber: "085178231007", // nomor tujuan
  });
  const [error, setError] = useState("");

const onChange = (e) => {
  const { name, value } = e.target;
  setFormDataLangganan({ ...formDataLangganan, [name]: value });
};


const onSubmit = (e) => {
  e.preventDefault();

  if (!formDataLangganan.message) {
    setError("Email wajib diisi!");
    return;
  }

  setError("");
  const number = "085178231007"; // format internasional
  const msg = encodeURIComponent(formDataLangganan.message);
  // Buka WhatsApp Web / App
  window.open(`https://wa.me/${number}?text=${msg}`, "_blank");
};








// --- handle form input ---
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};



  const testimonials = [
    {
      name: "Rina Putri",
      role: "Pemilik Toko Online",
      text: "Pelayanan cepat, desainnya keren banget! Website saya langsung naik traffic-nya.",
      img: testimoni1,
    },
    {
      name: "Dimas Arif",
      role: "Freelancer",
      text: "Saya puas banget, timnya komunikatif dan hasil websitenya sesuai harapan.",
      img: testimoni2,
    },
    {
      name: "Sarah Wijaya",
      role: "UMKM Kuliner",
      text: "niagawebsite bikin website usaha saya lebih dipercaya pelanggan!",
      img: testimoni3,
    },
    {
      name: "Melisa Handayani",
      role: "Event Organizer",
      text: "Dari awal konsultasi sampai website jadi, semuanya lancar. Desainnya sesuai keinginan saya, dan performanya ringan banget. Penjualan meningkat setelah pakai website ini!",
      img: testimoni4,
    },
    {
      name: "Fauzan Hakim",
      role: "Freelancer Designer",
      text: "Website portofolio saya jadi terlihat profesional. Banyak klien baru yang datang setelah saya tampilkan di media sosial. Sangat direkomendasikan!",
      img: testimoni5,
    },
    {
      name: "Lisa Hartono",
      role: "Marketing Manager",
      text: "Desain websitenya elegan, sesuai brand image kami. Mereka juga bantu optimasi SEO, jadi website kami mudah ditemukan di Google.",
      img: testimoni6,
    },
  ];


  return (
    <>
    <Box sx={{ fontFamily: "'Montserrat', sans-serif" }}>
      {/* ===== HERO SECTION ===== */}
      <Box
        sx={{
          bgcolor: "#31927b",
          color: "#fff",
          textAlign: "center",
          py: { xs: 8, md: 12 },
          mt: -8,
          px: 2,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            fontSize: { xs: "2rem", md: "3rem" },
          }}
        >
          Wujudkan Website Professionalmu Bersama{" "}
          <span
            style={{
              color: "#fcb81c",
              fontFamily: "Newt Serif Demi",
              fontStyle: "italic",
              fontSize: "1.3em",
            }}
          >
            niagawebsite
          </span>
        </Typography>
        <Typography
          className="font"
          sx={{
            maxWidth: "700px",
            mx: "auto",
            mb: 4,
            color: "#fff",
            opacity: 0.9,
            fontSize: 20
          }}
        >
          Kami membantu bisnis dan personal membangun Website yang cepat,
          modern, dan menarik serta responsive.
        </Typography>
        <Button
          onClick={handleClick}
          variant="contained"
          sx={{
            bgcolor: "#fcb81c",
            color: "#000",
            fontWeight: 700,
            px: 4,
            py: 1.5,
            borderRadius: "10px",
            "&:hover": { bgcolor: "#ffcf4d" },
          }}
        >
          Konsultasi Gratis Sekarang
        </Button>
      </Box>

      {/* ===== TENTANG niagawebsite ===== */}
      <Box sx={{ py: 10, px: { xs: 3, md: 10 }, textAlign: "center" }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: "#31927b" }}>
          Apa Itu{" "}
          <span
            style={{
              color: "#fcb81c",
              fontFamily: "Newt Serif Demi",
              fontStyle: "italic",
              fontSize: "1.4em",
            }}
          >
            niagawebsite
          </span>
          {" "}?
        </Typography>
        <Typography
          className="font"
          sx={{
            mt: 3,
            maxWidth: 800,
            mx: "auto",
            color: "#333",
            lineHeight: 1.8,
          }}
        >
          <b>niagawebsite</b> adalah platform jasa pembuatan website profesional
          yang berfokus pada desain modern, kecepatan optimal, dan kemudahan
          pengelolaan. Kami hadir untuk membantu Anda membangun citra digital
          yang kuat dan meningkatkan kepercayaan pelanggan Anda.
        </Typography>
      </Box>

      {/* ===== MENGAPA MEMILIH niagawebsite ===== */}
<Box
  sx={{
    position: "relative",
    py: 10,
    px: { xs: 3, md: 10 },
    textAlign: "center",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    minHeight: "100vh", // agar tinggi penuh layar
    display: "flex",
    justifyContent: "center", // pusatkan horizontal
    alignItems: "center",     // pusatkan vertikal
  }}
>
  {/* === PARTICLES === */}
  {init && (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
      }}
    >
      <Particles
        id="tsparticles-box"
        options={{
          preset: "links",
          fullScreen: { enable: false },
          background: { color: "#ffffff" },
          particles: {
            color: { value: "#31927b" },
            links: { color: "#31927b", distance: 150, enable: true, opacity: 0.4, width: 1 },
            move: { enable: true, speed: 2 },
            number: { value: 60, density: { enable: true, area: 800 } },
          },
        }}
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </Box>
  )}

  {/* === KONTEN === */}
  <Container
    sx={{
      position: "relative",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      width: "100%",
    }}
  >
    <Typography variant="h4" sx={{ fontWeight: 700, color: "#31927b" }}>
      Mengapa Memilih{" "}
      <span
        style={{
          color: "#fcb81c",
          fontFamily: "Newt Serif Demi",
          fontStyle: "italic",
          fontSize: "1.4em",
        }}
      >
        niagawebsite
      </span>
      {" "}?
    </Typography>

    {/* Grid Responsive */}
    <Grid
      container
      spacing={3}
      sx={{
        mt: 4,
        justifyContent: "center",
      }}
    >
      {fiturList.map((item, i) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          key={i}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Card
            sx={{
              width: "100%",
              maxWidth: 300,
              height: 380,
              borderRadius: "12px",
              overflow: "hidden",
              textAlign: "center",
              boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
              },
              background: "white",
              color: "#333",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {/* Gambar */}
            <Box
              component="img"
              src={item.img}
              alt={item.title}
              loading="lazy"
              sx={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "10px",
                mb: 2,
                transition: "transform 0.3s ease",
                "&:hover": { transform: "scale(1.03)" },
              }}
            />

            <CardContent sx={{ p: 0, flexGrow: 1 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  color: "#31927b",
                  mb: 0.5,
                  fontSize: "1rem",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                className="font"
                sx={{
                  color: "gray",
                  opacity: 0.9,
                  fontSize: "0.85rem",
                  lineHeight: 1.4,
                  px: 1.5,
                }}
              >
                {item.desc}
              </Typography>
            </CardContent>

            {/* Garis kiri, logo, garis kanan */}
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Box component="svg" viewBox="0 0 100 2" width="60" height="2" sx={{ stroke: "#31927b", fill: "none", strokeWidth: 2 }}>
                <line x1="0" y1="1" x2="100" y2="1" />
              </Box>

              <Box
                component="img"
                src={logo}
                alt="Logo"
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  border: "2px solid #31927b",
                  p: 1,
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.1)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  },
                  cursor: "pointer",
                }}
                onClick={() => console.log("Logo diklik!")}
              />

              <Box component="svg" viewBox="0 0 100 2" width="60" height="2" sx={{ stroke: "#31927b", fill: "none", strokeWidth: 2 }}>
                <line x1="0" y1="1" x2="100" y2="1" />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>





      {/* ===== PAKET WEBSITE ===== */}
<Box id="paket-website" sx={{ py: 10, px: { xs: 3, md: 10 }, textAlign: "center" }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: "#31927b" }}>
        Paket Website{" "}
        <span
          style={{
            color: "#fcb81c",
            fontFamily: "Newt Serif Demi",
            fontSize: "1.4em",
            fontStyle: "italic",
          }}
        >
          niagawebsite
        </span>

      </Typography>

      {/* === GRID PAKET === */}
      <Grid container spacing={4} sx={{ mt: 5, justifyContent: "center" }}>
  {pricingPlans.map((pkg, i) => (
    <Grid item xs={12} sm={6} md={4} key={i}>
      <Card
        sx={{
          position: "relative",
          borderRadius: "20px",
          border: "2px solid #31927b",
          boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
          p: 2,
          transition: "transform 0.2s",
          "&:hover": { transform: "translateY(-5px)" },
        }}
      >
        {/* Gambar pojok kanan atas */}
        <Box
          component="img"
          src={pkg.img}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            width: 55,
            height: "auto",
          }}
        />

        <CardContent>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#31927b", mb: 1 }}
          >
            {pkg.name}
          </Typography>

          <Typography
            variant="h5"
            sx={{ color: "#fcb81c", fontWeight: 700, mb: 2 }}
          >
            {pkg.price}
          </Typography>

          {/* === Daftar fitur === */}
          <Box component="ul" sx={{ listStyle: "none", pl: 0, color: "#333" }}>
            {pkg.features.map((f, j) => (
              <Box
                key={j}
                component="li"
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                  mb: 1.2,
                }}
              >
                <Box
                  sx={{
                    border: "2px solid #31927b",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    mt: "2px",
                  }}
                >
                  <CheckIcon sx={{ color: "#31927b", fontSize: 16 }} />
                </Box>

                <Box sx={{ textAlign: "left", flexGrow: 1 }}>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "0.95rem", lineHeight: 1.5 }}
                  >
                    {f}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            onClick={() => handleClickPaket()}
            sx={{
              bgcolor: "#31927b",
              color: "#fff",
              mt: 3,
              borderRadius: "10px",
              fontWeight: 600,
              "&:hover": { bgcolor: "#267864" },
            }}
          >
            <span className="font">Pilih Paket</span>
          </Button>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>


    </Box>

      {/* ===== TESTIMONI ===== */}
     <Box
  id="testimoni"
  sx={{
    bgcolor: "#f7f7f7",
    py: 10,
    px: { xs: 3, md: 10 },
    textAlign: "center",
  }}
>
  <Typography variant="h4" sx={{ fontWeight: 700, color: "#31927b" }}>
    Testimoni Pelanggan
  </Typography>

  <Grid
    container
    spacing={4}
    sx={{
      mt: 5,
      justifyContent: "center",
    }}
  >
    {testimonials.slice(0, 6).map((t, i) => (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        key={i}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Card
          sx={{
            borderRadius: "20px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            p: 3,
            width: "100%",
            maxWidth: 330,
            textAlign: "center",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              transform: "translateY(-5px)",
              boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
            },
          }}
        >
          <Box
            component="img"
            src={t.img}
            alt={t.name}
            loading="lazy"
            sx={{
              width: 80,
              height: 80,
              mx: "auto",
              mb: 2,
              border: "3px solid #31927b",
              borderRadius: "50%",         // ini membuatnya bulat seperti Avatar
              objectFit: "cover",          // jaga aspek rasio
            }}
          />

          <Typography
            sx={{
              fontStyle: "italic",
              mb: 2,
              color: "#333",
              fontSize: "0.95rem",
              lineHeight: 1.6,
            }}
          >
            "{t.text}"
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              color: "#31927b",
              fontSize: "1.05rem",
            }}
          >
            {t.name}
          </Typography>
          <Typography sx={{ color: "#777", fontSize: "0.9rem" }}>
            {t.role}
          </Typography>
        </Card>
      </Grid>
    ))}
  </Grid>
</Box>


      {/* ===== FOOTER ===== */}
      <Box
      component="footer"
      sx={{
        bgcolor: "#f7f7f7",
        color: "#333",
        mt: 10,
        pt: 8,
        pb: 4,
        px: { xs: 3, md: 10 },
      }}
    >
      <Grid container spacing={6}>
        {/* Kolom 1: Logo & Deskripsi */}
        <Grid item xs={12} md={4}>
          <Box
            component="img"
            src={logo}
            alt="niagawebsite Logo"
            sx={{ height: 100, mb: 2 }}
          />
          <Typography className="font" sx={{ mb: 2 }}>
            <b style={{ color: "#31927b" }}>niagawebsite</b> adalah penyedia jasa
            pembuatan website profesional yang membantu Anda membangun identitas
            digital yang kuat. Kami percaya bahwa setiap bisnis berhak tampil
            modern dan mudah ditemukan di internet.
          </Typography>
          <Typography className="font" sx={{ mb: 2 }}>
            Dengan kombinasi desain kreatif, performa cepat, dan strategi digital
            yang efektif, kami hadir untuk membantu bisnis Anda berkembang melalui
            website yang menarik, responsif, dan terpercaya.
          </Typography>
        </Grid>

        {/* Kolom 2: Navigasi */}
        <Grid item xs={12} md={3}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#31927b", mb: 2 }}
          >
            Navigasi
          </Typography>
          {["Beranda", "Layanan", "Paket Website", "Portofolio", "Testimoni", "Kontak"].map(
            (item, i) => (
              <Typography
                className="font"
                key={i}
                sx={{
                  mb: 1,
                  cursor: "pointer",
                  "&:hover": { color: "#fcb81c" },
                  transition: "0.3s",
                }}
              >
                {item}
              </Typography>
            )
          )}
        </Grid>

        

        {/* Kolom 3: Informasi Kontak */}
        <Grid item xs={12} md={3}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#31927b", mb: 2 }}
          >
            Hubungi Kami
          </Typography>
            {/* Google Maps */}
            <Box
              sx={{
                width: "100%",
                height: 380,
                borderRadius: 2,
                overflow: "hidden",
                mb: 2,
              }}
            >
              <iframe
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.035632779391!2d106.8466307749855!3d-6.514347564293742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69e9e9d33f89cf%3A0xe1747460dbc0b99b!2sJl.%20Madrasah%20No.91%2C%20RT.3%2FRW.9%2C%20Pekayon%2C%20Ps.%20Rebo%2C%20Jakarta%20Timur%2013710!5e0!3m2!1sid!2sid!4v1732518760000"
              ></iframe>
            </Box>
          <Typography className="font" sx={{ mb: 1 }}>
            📍 Jln Madrasah No. 91, RT.3/RW.9, Pekayon, Pasar Rebo, Jakarta timur 13710
          </Typography>
          <Typography className="font" sx={{ mb: 1 }}>📞 085178231007</Typography>
          <Typography className="font" sx={{ mb: 2 }}>✉️ niagawebsite21@gmail.com</Typography>
          <Typography className="font" sx={{ color: "#555" }}>
            Kami selalu siap membantu Anda membangun website impian. Hubungi kami
            untuk konsultasi gratis dan dapatkan solusi terbaik untuk kebutuhan
            digital Anda.
          </Typography>
        </Grid>
      </Grid>

      {/* Garis Pembatas */}
      <Box
        sx={{
          mt: 8,
          mb: 2,
          borderTop: "1px solid #ddd",
          pt: 3,
          textAlign: "center",
        }}
      >
        <Typography className="font" sx={{ fontSize: "0.9rem", color: "#666" }}>
          © {new Date().getFullYear()}{" "}
          <b style={{ color: "#31927b" }}>niagawebsite</b> — Semua hak cipta
          dilindungi. Dibuat dengan semangat dan inovasi 💡 untuk membantu Anda
          memiliki website yang lebih baik.
        </Typography>
      </Box>
    </Box>
    </Box>

    <Box
      id="whatsapp-btn"
      sx={{
        position: "fixed",
        bottom: { xs: 16, md: 20 },
        right: { xs: 16, md: 20 },
        zIndex: 2147483647, // nilai maksimum
        pointerEvents: "auto",
      }}
    >
      <span className="pulse-ring"></span>
      <IconButton
        onClick={handleClick}
        sx={{
          bgcolor: "#25D366",
          "&:hover": { bgcolor: "#1ebe5d" },
          color: "#fff",
          width: { xs: 52, md: 60 },
          height: { xs: 52, md: 60 },
          borderRadius: "50%",
          boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
          zIndex: 2147483647,
        }}
      >
        <WhatsAppIcon sx={{ fontSize: { xs: 28, md: 32 } }} />
      </IconButton>
    </Box>
    </>
  );
}
